import { render, staticRenderFns } from "./DashboardContratos.vue?vue&type=template&id=12dcf262&scoped=true"
import script from "./DashboardContratos.vue?vue&type=script&lang=js"
export * from "./DashboardContratos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dcf262",
  null
  
)

export default component.exports